import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TGetContractorsRequestSchema,
  TGetContractorsResponseSchema,
} from "./getContractors.schema";

export const getContractors = (axios: IAxiosInstance) => {
  return async (params: TGetContractorsRequestSchema) => {
    const response = await axios.noRetry.get<
      IApiResponse<TGetContractorsResponseSchema>
    >(`/api/getMyContractors`, {
      params,
    });
    const data = response.data;

    return data;
  };
};
